import React, { useState } from 'react';
import './FaqSection.css';
import { FAQ_LIST, CREDIT_UNION, LINKS } from '../../assets/constants';

const FaqSection = () => {
  const leftColumnFaqs = FAQ_LIST.filter((_, index) => index % 2 === 0); 
  const rightColumnFaqs = FAQ_LIST.filter((_, index) => index % 2 !== 0); 

  const [activeLeftFaqId, setActiveLeftFaqId] = useState('faq1'); 
  const [activeRightFaqId, setActiveRightFaqId] = useState(null); 

  const handleToggleLeft = (id) => {
    setActiveLeftFaqId((prevId) => (prevId === id ? null : id));
  };

  const handleToggleRight = (id) => {
    setActiveRightFaqId((prevId) => (prevId === id ? null : id));
  }; 

  const renderAnswer = (answer) => {
    if (typeof answer === 'string') {
      return <p className="faq-answer-text">{answer}</p>;
    } else if (answer.type === 'link') {
      return (
        <p className="faq-answer-text">
          {answer.text}
          <a href={answer.href} target="_blank" rel="noopener noreferrer" className="faq-link">
            {answer.linkText}
          </a>
          {answer.postText}
        </p>
      );
    } else if (answer.type === 'list') {
      return (
        <div className="faq-answer-text">
          {answer.text && <p>{answer.text}</p>}
          <ul className="faq-list">
            {answer.items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          {answer.postText && <p>{answer.postText}</p>}
        </div>
      );
    }
    return null;
  };

  return (
    <section className="faq-section">
      <div className="layout-container">
        <header className="faq-header">
          <h2 className="faq-heading">FAQ's</h2>
          <p className="faq-subheading"> 
            Having questions about auto loan refinancing is common with factors like eligibility,
            documentation, potential savings, and application steps to consider. We’ve compiled some
            frequently asked questions to provide clarity and simplify the process.
            <span className="faq-highlight"> Still have a question?</span> Reach out to us at{' '}
            <a href={`tel:${CREDIT_UNION.INFO.PHONE}`}>{CREDIT_UNION.INFO.PHONE}</a> or ask at {' '}
            <a href={`mailto:${CREDIT_UNION.INFO.EMAIL}`}>{CREDIT_UNION.INFO.EMAIL}</a> and one of
            our team members will assist you.
          </p>
        </header>

        <div className="faq-grid">
          {/* Left Column */}
          <div className="faq-column"> 
            {leftColumnFaqs.map((faq) => {
              const isActive = activeLeftFaqId === faq.id;
              return (
                <div
                  key={faq.id}
                  className={`faq-item ${isActive ? 'active' : ''}`}
                  onClick={() => handleToggleLeft(faq.id)}
                >
                  <div className="faq-header-inner">
                    <h3 className="faq-question">{faq.question}</h3>
                    <span className="faq-icon">{isActive ? '−' : '+'}</span>
                  </div>
                  {isActive && <div className="faq-answer">{renderAnswer(faq.answer)}</div>}
                </div>
              );
            })}
          </div>

          {/* Right Column */}
          <div className="faq-column">
            {rightColumnFaqs.map((faq) => {
              const isActive = activeRightFaqId === faq.id;
              return (
                <div
                  key={faq.id}
                  className={`faq-item ${isActive ? 'active' : ''}`}
                  onClick={() => handleToggleRight(faq.id)}
                >
                  <div className="faq-header-inner">
                    <h3 className="faq-question">{faq.question}</h3>
                    <span className="faq-icon">{isActive ? '−' : '+'}</span>
                  </div>
                  {isActive && <div className="faq-answer">{renderAnswer(faq.answer)}</div>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;